/** Matches backend `computeBookingAmounts` / admin receipt rules. */
export const ADVANCE_CAP = 5000;

/** Within this many days of departure, full trip fee is due at booking (no advance split). */
export const ADVANCE_WINDOW_DAYS = 40;

/** Remaining balance due this many days before departure. */
export const REMAINING_DUE_DAYS_BEFORE_DEPARTURE = 20;

export function remainingDueDateFromDeparture(departureDate) {
  if (!departureDate) return null;
  const raw = departureDate instanceof Date ? departureDate : new Date(departureDate);
  if (Number.isNaN(raw.getTime())) return null;
  const due = new Date(raw.getFullYear(), raw.getMonth(), raw.getDate());
  due.setDate(due.getDate() - REMAINING_DUE_DAYS_BEFORE_DEPARTURE);
  return due;
}
